import React, { useContext } from 'react'
import { UserContext } from '../../../App'
import { LoadingFull } from '../../loading'
import ChatsSingle from './chats_single'

const Chats = ({chats, selected, setSelected, chatsOpen, setChatsOpen, loadingChats}) => {
  const { user } = useContext(UserContext)
  return (
    <div className={"chats p-5 bg-white lg:flex-[0.5] flex lg:flex flex-col gap-5 border border-neutral-100 w-full transition-[] duration-500 ease-out z-10 overflow-x-hidden" + (chatsOpen ? "" : " -translate-x-full lg:translate-x-[0]")}>
        <h1 className="text-lg md:text-xl font-semibold">Dine samtaler</h1>
        <div className="flex flex-col gap-1 overflow-y-auto h-full">
          {(!loadingChats) ?
              (chats.length <= 0) ?
                  <p className="text-sm text-center h-full content-center italic">Du har ingen samtaler i øjeblikket</p>
              :
                  chats.map((chat) => {
                      return <ChatsSingle chat={chat} selected={selected} setSelected={setSelected} setChatsOpen={setChatsOpen} />
                  })
          :
              <LoadingFull />}
        </div>
    </div>
  )
}

export default Chats